import {
  getInt32,
} from "@surya-digital/leo-ts-types";

export interface SpocManagementPageIndexDTO {
  items: number;
}

export class SpocManagementPageIndex {
  readonly isSpocManagementPageIndexSpocManagementPageIndex: boolean = true;

  readonly items: number;

  static readonly constraints = {
    "items": {
      "minValue": 0,
    }
  }

  constructor(
  items: number
  ) {
    SpocManagementPageIndex.validateItems(items);
    this.items = items;
  }

  static fromDTO(dto: SpocManagementPageIndexDTO): SpocManagementPageIndex {
    const items = getInt32(dto, "items", InvalidSpocManagementPageIndexItemsError);
    return new SpocManagementPageIndex(
      items
    );
  }

  toDTO(): SpocManagementPageIndexDTO {
    const dto: SpocManagementPageIndexDTO = {
        items: this.items
    };
    return dto;
  }
  private static validateItems = (items: number): void => {
    if(items < 0) {
      throw new InvalidSpocManagementPageIndexItemsMinValueError(
        0,
        `Attribute items has value ${items}. Min value is 0.`
      );
    }
  }
  
}

SpocManagementPageIndex.prototype.toString = function toString(): string {
  return `SpocManagementPageIndex(items='${this.items}')`;
};

export class InvalidSpocManagementPageIndexError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSpocManagementPageIndexError";
  }
}
export class InvalidSpocManagementPageIndexItemsError extends InvalidSpocManagementPageIndexError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSpocManagementPageIndexItemsError";
  }
}

export class InvalidSpocManagementPageIndexItemsMinValueError extends InvalidSpocManagementPageIndexItemsError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSpocManagementPageIndexItemsMinValueError";
  }
}
